import * as React from 'react'
import ModulesMappingConfiguration from './modulesMappingConfiguration'

export const loadModules = (zone, moduleResults) => {
  const modules = []
  moduleResults.forEach(moduleInfo => {
    const Module = ModulesMappingConfiguration[moduleInfo.moduleName]
    modules.push(<Module key={moduleInfo.moduleName} data-testid={`module-${moduleInfo.moduleName.toLowerCase()}-pp`} {...{ zone, ...moduleInfo }} />)
  })

  return modules
}

const ModuleLoader = ({ zone, moduleResults }) => loadModules(zone, moduleResults)

export default ModuleLoader
